"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturesListItem = FeaturesListItem;
exports.default = PlanBoxItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _image = require("@site/pattern-library-core/image");
var _list = _interopRequireWildcard(require("@site/pattern-library-core/list"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _index = _interopRequireDefault(require("../actions/index"));
var _tooltip = _interopRequireDefault(require("@site/pattern-library-core/tooltip"));
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @module PlanBoxItem */

/* PL */

const PlanBoxImg = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "PlanBoxImg",
  class: "pl-p1tr8vpq",
  vars: {
    "p1tr8vpq-0": [({
      imgType
    }) => imgType === 'figure' ? '12.5rem' : '13.563rem'],
    "p1tr8vpq-1": [({
      align
    }) => align === 'start' ? 'flex-start' : `${align}`]
  }
});
const PlanBoxItemElement = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PlanBoxItemElement",
  class: "pl-prka3ch",
  vars: {
    "prka3ch-0": [({
      align
    }) => `${align}`],
    "prka3ch-2": [({
      gridSettings
    }) => `${gridSettings.tabletColumn}`],
    "prka3ch-3": [({
      gridSettings
    }) => `fl-${gridSettings.tabletRow}`],
    "prka3ch-4": [({
      gridSettings
    }) => `im-${gridSettings.tabletRow}`],
    "prka3ch-5": [({
      gridSettings
    }) => `ts-${gridSettings.tabletRow}`],
    "prka3ch-6": [({
      gridSettings
    }) => `ds-${gridSettings.tabletRow}`],
    "prka3ch-7": [({
      gridSettings
    }) => `ps-${gridSettings.tabletRow}`],
    "prka3ch-8": [({
      gridSettings
    }) => `cs-${gridSettings.tabletRow}`],
    "prka3ch-9": [({
      gridSettings
    }) => `fls-${gridSettings.tabletRow}`],
    "prka3ch-10": [({
      gridSettings
    }) => `${gridSettings.tabletRowStart}/${gridSettings.tabletRowEnd}`],
    "prka3ch-13": [({
      gridSettings
    }) => `${gridSettings.desktopColumn}`],
    "prka3ch-14": [({
      gridSettings
    }) => `fl-${gridSettings.desktopRow}`],
    "prka3ch-15": [({
      gridSettings
    }) => `im-${gridSettings.desktopRow}`],
    "prka3ch-16": [({
      gridSettings
    }) => `ts-${gridSettings.desktopRow}`],
    "prka3ch-17": [({
      gridSettings
    }) => `ds-${gridSettings.desktopRow}`],
    "prka3ch-18": [({
      gridSettings
    }) => `ps-${gridSettings.desktopRow}`],
    "prka3ch-19": [({
      gridSettings
    }) => `cs-${gridSettings.desktopRow}`],
    "prka3ch-20": [({
      gridSettings
    }) => `fls-${gridSettings.desktopRow}`],
    "prka3ch-21": [({
      gridSettings
    }) => `${gridSettings.desktopRowStart}/${gridSettings.desktopRowEnd}`]
  }
});
const Description = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Description",
  class: "pl-d7218l7"
});
const FeaturesListContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FeaturesListContainer",
  class: "pl-f1bola48"
});
const HeaderToggle = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeaderToggle",
  class: "pl-hxawo0q"
});
const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-csn2232"
});
const Flag = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Flag",
  class: "pl-fkr54in",
  vars: {
    "fkr54in-0": [({
      flagColor = `${_intents.default.ux.feedbackWarning.feedbackColor}`
    }) => flagColor]
  }
});

/**
 * Features List for Product Card Component
 *
 * @param {Object} props React props
 * @param {Array<string>} props.features Product Features
 * @param {string} props.iconType Ux Icon Type for Features
 * @param {string} props.iconColor Icon Color for Features
 * @returns {React.ReactElement} Features List Component
 * @public
 */
function FeaturesListItem({
  featuresHeader,
  featuresList
}) {
  if (!featuresList.items) return null;
  return /*#__PURE__*/_react.default.createElement(FeaturesListContainer, {
    className: "feature-list",
    tabIndex: "-1",
    "data-cy": "features-list-item"
  }, /*#__PURE__*/_react.default.createElement(HeaderToggle, null, featuresHeader), /*#__PURE__*/_react.default.createElement(_list.default, featuresList));
}
FeaturesListItem.propTypes = {
  featuresHeader: _propTypes.default.string,
  featuresList: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.shape(_list.ListItem.propTypes)))
};

/**
 * Product Card Component
 * @memberof module:PlanBoxItem
 *
 * @param {Object} props React props
 * @param {string} props.align Content alignment for the plan box
 * @param {string} props.flagText Flag Text
 * @param {string} props.flagColor Flag Color
 * @param {object} props.image Image object
 * @param {string} props.title Product Title
 * @param {string} props.description Product Description
 * @param {Object} props.price Product Price
 * @param {Object} props.cta CTA on the product card
 * @param {Object} props.featuresList Product Features
 * @param {string} props.disclaimer Product Disclaimer
 * @param {Object} props.gridSettings grid Settings for alignment within the section
 * @returns {React.ReactElement} Product Card component
 * @public
 */
function PlanBoxItem({
  id,
  align = 'start',
  flagText,
  flagColor,
  image = {},
  imgType,
  title,
  description,
  descriptionTooltip,
  price = {
    priceLockupVersion: 2
  },
  cta,
  featuresHeader = 'Details',
  featuresList,
  gridSettings
}) {
  const {
    url: imgSrc,
    altText
  } = image;
  return /*#__PURE__*/_react.default.createElement(PlanBoxItemElement, {
    id: `id-${id}`,
    gridSettings: gridSettings,
    role: "article",
    className: "article",
    "data-cy": "item",
    align: align,
    hasFlag: !!flagText
  }, imgSrc && /*#__PURE__*/_react.default.createElement(PlanBoxImg, {
    imgType: imgType,
    src: imgSrc,
    alt: altText,
    align: align
  }), flagText && /*#__PURE__*/_react.default.createElement(Flag, {
    className: "flag",
    flagColor: flagColor.rgb
  }, " ", flagText, " "), title && /*#__PURE__*/_react.default.createElement(_text.default.h3, {
    as: "title",
    className: "title",
    text: title
  }), description && /*#__PURE__*/_react.default.createElement(Description, {
    className: "description"
  }, description, descriptionTooltip && /*#__PURE__*/_react.default.createElement(_tooltip.default, descriptionTooltip)), price && /*#__PURE__*/_react.default.createElement(_price.default, (0, _extends2.default)({
    align: align
  }, price)), cta && /*#__PURE__*/_react.default.createElement(CTAContainer, {
    className: "cta"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: [cta]
  })), featuresList && /*#__PURE__*/_react.default.createElement(FeaturesListItem, {
    featuresHeader: featuresHeader,
    featuresList: featuresList
  }));
}
PlanBoxItem.propTypes = {
  id: _propTypes.default.string,
  align: _propTypes.default.oneOf(['start', 'center']),
  flagText: _propTypes.default.node,
  flagColor: _propTypes.default.shape({
    rgb: _propTypes.default.string
  }),
  image: _propTypes.default.shape(_image.imgPropShape),
  imgType: _propTypes.default.oneOf(['figure', 'illustration']),
  title: _propTypes.default.string,
  description: _propTypes.default.node,
  descriptionTooltip: _propTypes.default.shape(_tooltip.default.propTypes),
  price: _propTypes.default.oneOfType([_propTypes.default.shape({
    priceLockupVersion: _propTypes.default.oneOf([1, 2]),
    ..._price.default.propTypes
  })]),
  cta: _propTypes.default.shape(_merchButton.NSMerchButton.propTypes),
  featuresHeader: _propTypes.default.string,
  featuresList: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.shape(_list.ListItem.propTypes))),
  gridSettings: _propTypes.default.shape({
    tabletRow: _propTypes.default.number.isRequired,
    tabletColumn: _propTypes.default.number.isRequired,
    tabletRowStart: _propTypes.default.number.isRequired,
    tabletRowEnd: _propTypes.default.number.isRequired,
    desktopRow: _propTypes.default.number.isRequired,
    desktopColumn: _propTypes.default.number.isRequired,
    desktopRowStart: _propTypes.default.number.isRequired,
    desktopRowEnd: _propTypes.default.number.isRequired
  })
};